import script from "./TicketDetailModal.vue?vue&type=script&setup=true&lang=js"
export * from "./TicketDetailModal.vue?vue&type=script&setup=true&lang=js"

import "./TicketDetailModal.vue?vue&type=style&index=0&id=149e0326&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-149e0326"]])

export default __exports__